import React, { useState } from 'react';

import PaginationInfo from 'CommonComponents/PaginationInfo';
import TablePagination from 'CommonComponents/TablePagination';
import TextButton from 'CommonComponents/TextButton';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';
import TrashIcon from 'Assets/icons/trash.svg';
import UserCircleIcon from 'Assets/icons/user-circle.svg';

function AccountsTableRow(props) {
    const [account] = useState(props.account);
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [to, setTo] = useState(1);
    const [from, setFrom] = useState(1);
    const [total, setTotal] = useState(1);
    const [showUsers, setShowUsers] = useState(false);

    const [keyUser] = account.users;
    const hasUsers = users.length > 0;

    const defaultUrl = props.fetchUsersUrl.replace('EVENT_SLUG', account.slug) + '?filter=exclude-super-admin&&per_page=' + perPage;

    function clickRow() {
        if (!showUsers) {
            fetchUsers();
            setShowUsers(true);
        } else {
            setShowUsers(false);
        }
    }

    const combineFetchUrl = (p = null, pp = null) => {
        return props.fetchUsersUrl.replace('EVENT_SLUG', account.slug) + '?filter=exclude-super-admin&&per_page=' + (pp || perPage) + '&page=' + (p || page);
    };

    const fetchUsers = (url = null) => {
        setLoading(true);
        const fetchUrl = url || defaultUrl;

        axios
            .get(fetchUrl)
            .then((res) => {
                const { data, to, from, total, last_page } = res.data;
                if (data !== undefined) {
                    setUsers(data);
                    setTo(to);
                    setFrom(from);
                    setTotal(total);
                    setLastPage(last_page);
                }

                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setUsers([]);
                setLoading(false);
            });
    };

    function pageChange(data) {
        const url = combineFetchUrl(data.selected + 1);
        setPage(+data.selected + 1);
        fetchUsers(url);
    }

    return (
        <>
            {props.show && (
                <tr key={account.id} className="cursor-pointer tw-align-top !tw-bg-white">
                    <td onClick={clickRow}>
                        <div className="tw-flex tw-items-center tw-gap-x-2">
                            {account.name}
                            {showUsers ? <ChevronUpIcon className="tw-w-2.5 tw-h-2.5" /> : <ChevronDownIcon className="tw-w-2.5 tw-h-2.5" />}
                        </div>
                    </td>
                    <td onClick={clickRow}>{keyUser !== undefined && `${keyUser.first_name} ${keyUser.last_name} ${keyUser.email}`}</td>
                    <td onClick={clickRow}>{account.seats}</td>
                    <td onClick={clickRow}>{account.users_count}</td>
                    {!!props.featureEventDeletion && (
                        <td>
                            <TextButton variant="danger" onClick={() => props.confirmDeleteHandler(props.account)}>
                                <TrashIcon className="tw-w-3 tw-h-3" /> {$t('Delete')}
                            </TextButton>
                        </td>
                    )}
                </tr>
            )}
            {showUsers && props.show && (
                <tr className="!tw-bg-blue-25/50">
                    <td colSpan={props.featureEventDeletion ? '5' : '4'}>
                        <div className="tw-flex tw-items-center tw-space-x-3 tw-mb-6">
                            <PaginationInfo to={to} from={from} total={total} />
                            <TablePagination lastPage={lastPage} pageChange={pageChange} />
                        </div>
                        <div className="inbud-table_wrapper">
                            <table className="inbud-table">
                                <thead>
                                    <tr className="*:!tw-bg-charcoal-25">
                                        <th className="tw-w-2/5">Name</th>
                                        <th className="tw-w-1/2">Email</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!hasUsers ? (
                                        loading ? (
                                            <tr>
                                                <td colSpan="3">{$t('Loading')}...</td>
                                            </tr>
                                        ) : (
                                            <tr>
                                                <td colSpan="3">There are no users allocated to this event</td>
                                            </tr>
                                        )
                                    ) : (
                                        users.map((user) => {
                                            return (
                                                <tr key={user.id}>
                                                    <td>{`${user.first_name} ${user.last_name}`}</td>
                                                    <td>{user.email}</td>
                                                    <td>
                                                        <TextButton variant="primary" onClick={() => props.onImpersonate(user)}>
                                                            <UserCircleIcon className="tw-w-3 tw-h-3" /> {$t('Impersonate')}
                                                        </TextButton>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </td>
                </tr>
            )}
        </>
    );
}

export default AccountsTableRow;
